import { render } from "./IdentityDocumentUpload.vue?vue&type=template&id=efc26e3c&scoped=true"
import script from "./IdentityDocumentUpload.vue?vue&type=script&lang=js"
export * from "./IdentityDocumentUpload.vue?vue&type=script&lang=js"

import "./IdentityDocumentUpload.vue?vue&type=style&index=0&id=efc26e3c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-efc26e3c"

export default script